import React from 'react';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { Slider as MuiSlider } from '@material-ui/core';
import theme from 'utils/theme';
import './Slider.css';

const classes = {
    root: 'Slider',
    rail: 'Slider__rail',
    track: 'Slider__track',
    thumb: 'Slider__thumb',
};
export default function Slider({
    value,
    minValue,
    maxValue,
    onChange,
    onChangeCommitted,
}) {
    return (
        <MuiThemeProvider theme={theme}>
            <MuiSlider
                value={value}
                min={minValue}
                max={maxValue}
                classes={classes}
                onChange={onChange}
                onChangeCommitted={onChangeCommitted}
            />
        </MuiThemeProvider>
    );
}
